module.exports = __webpack_public_path__ + "img/playtech.3095da39.png";